import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

export function Eyebrow({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "text-[10px] font-semibold uppercase tracking-eyebrow text-muted",
        className,
      )}
    >
      {children}
    </div>
  );
}
